import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { sendFormData } from '../utils/WhatsApp';

const ContactPage = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        mobile: "",
        serviceType: "",
        message: ""
    });

    const handleChange = (e) => {
        let { name, value } = e.target;

        if (name === "mobile") {
            // Remove country code if pasted (+91 or 91)
            value = value.replace(/^\+?91/, "");
    
            // Remove leading zeros
            value = value.replace(/^0+/, "");
    
            // Remove spaces
            value = value.replace(/\s/g, "");
    
            // Only keep numeric values
            value = value.replace(/\D/g, "");
    
            // Limit to 10 digits
            value = value.slice(0, 10);
        }

        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        
        try {
            await sendFormData(formData, 'Contact Form');
            toast.success("Details send, Our team will contact you soon.", {
                position: "top-center",
                autoClose: 3000
            });
            setFormData({
                name: "",
                email: "",
                mobile: "",
                serviceType: "",
                message: ""
            });
        } catch (error) {
            toast.error("Failed to send. Please try again.", {
                position: "top-center",
                autoClose: 3000
            });
            console.error('error:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="other-pages-main-section contact-page-fin">
                <h2 className="other-pages-title">Contact Us</h2>
                <p>
                    <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>Home</span> /
                    <span onClick={() => navigate("/contact-loan-experts")} style={{ cursor: "pointer" }}>Contact</span>
                </p>
            </div>
            <section className="contact-page-smco">
                <div className="contact-page-smco-container">
                    <div className="contact-page-smco-left">
                        <h3>Contact Us</h3>
                        <form onSubmit={handleSubmit}>
                            <label>Name</label>
                            <input 
                                type="text" 
                                name="name" 
                                value={formData.name} 
                                className="contact-page-smco-input" 
                                onChange={handleChange} 
                                placeholder="Your Name" 
                                required
                            />

                            <label>Email</label>
                            <input 
                                type="email" 
                                name="email" 
                                value={formData.email} 
                                className="contact-page-smco-input" 
                                onChange={handleChange} 
                                placeholder="Your Email" 
                                required
                            />

                            <label>Phone Number</label>
                            <input 
                                type="text" 
                                name="mobile" 
                                value={formData.mobile} 
                                className="contact-page-smco-input" 
                                placeholder="Your Number" 
                                onChange={handleChange}
                                required
                            />

                            <label>Service Type</label>
                            <select 
                                className="contact-page-smco-input" 
                                name="serviceType" 
                                value={formData.serviceType} 
                                onChange={handleChange}
                                required
                            >

                                <option value="">Select Service</option>
                                <option value="Personal Loan - Quick & Hassle-Free Approval">Personal Loan</option>
                                <option value="Business Loan - Fuel Your Growth">Business Loan</option>
                                <option value="Home Loan - Your Dream Home Awaits">Home Loan</option>
                                <option value="Mortgage Loan - Smart Financing for Homeowners">Mortgage Loan</option>
                                <option value="Working Capital Loan - Maintain Cash Flow">Working Capital Loan</option>
                                <option value="Loan Against Shares - Leverage Your Investments">Loan Against Shares</option>
                                <option value="Life Insurance - Secure Your Future">Life Insurance</option>
                                <option value="General Insurance - Protect What Matters">General Insurance</option>
                                <option value="Health Insurance - Secure Your Well-being">Health Insurance</option>
                                <option value="Vehicle Insurance - Protect Your Ride">Vehicle Insurance</option>
                                <option value="Mutual Funds - Grow Your Wealth">Mutual Funds</option>

                            </select>

                            <label>Message</label>
                            <textarea 
                                className="contact-page-smco-input" 
                                placeholder="Your Message" 
                                name="message" 
                                value={formData.message} 
                                onChange={handleChange}
                            ></textarea>

                            <button type="submit" className="contact-page-smco-button" disabled={loading}>
                                {loading ? <span className="spinner"></span> : "Submit"}
                            </button>
                        </form>
                    </div>
                    <div className="contact-page-smco-right">
                        <h3>Office Information</h3>
                        <p><strong>Office Timing:</strong> 10:00 AM - 9:00 PM</p>
                        <p><strong>Address:</strong> Office 07, Ajanta Square Mall, Market Lane, Near Borivali Court, Borivali West Mumbai - 400092</p>
                        <p><strong>Phone:</strong> +91 7506550715</p>
                        <p><strong>Email:</strong> surendra.pal@moneyvision.co</p>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ContactPage;

